import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "333",
  "slug": "most-populous-cities-in-the-world",
  "title": "The Most Populous Cities: Why the Definition Matters",
  "excerpt": "Jakarta leads the UN’s 2025 comparison; city boundaries explain why older lists look different.",
  "date": "2026-06-03",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1499092346589-b9b6be3e94b2?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHxjaXR5JTIwc2t5bGluZSUyMGFlcmlhbHxlbnwxfDB8fHwxNzgwNDc3MzU4fDA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "2 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Jakarta leads the United Nations' 2025 city population comparison, followed by Dhaka and Tokyo. Their estimated populations are about 41.9 million, 36.6 million, and 33.4 million respectively. These are estimates for the urban areas defined in that dataset, not counts within each city's administrative boundary."
    },
    {
      "type": "paragraph",
      "text": "The source is World Urbanization Prospects 2025. Its harmonised Degree of Urbanization approach changes how cities are compared across countries. Do not read a change from an older ranking as if millions of people suddenly moved between cities."
    },
    {
      "type": "heading",
      "text": "Three boundaries, three questions"
    },
    {
      "type": "list",
      "items": [
        "An administrative city counts people inside a government boundary.",
        "A built-up urban area follows settlement patterns, using the thresholds defined by the dataset.",
        "A metropolitan region includes places linked by commuting and other daily relationships, potentially with gaps between settlements."
      ]
    },
    {
      "type": "paragraph",
      "text": "Before comparing two figures, check that their reference year and boundary method match. A municipality containing extensive countryside is answering a different question from a map of continuous urban development."
    },
    {
      "type": "heading",
      "text": "What a satellite image can show"
    },
    {
      "type": "paragraph",
      "text": "An image can help you trace a city's built-up footprint, rivers, transport corridors, and gaps of open land. It cannot tell you how many people occupy each building. Two areas with similar roofs and road coverage may house different numbers of people."
    },
    {
      "type": "paragraph",
      "text": "For a map exercise, trace the visible edge of a city and then compare it with its administrative boundary. Note where suburbs cross that boundary. This makes the counting problem concrete before you reach for a ranking."
    }
  ],
  "sources": [
    {
      "title": "UN: World Urbanization Prospects 2025",
      "url": "https://population.un.org/wup/"
    },
    {
      "title": "Destatis: largest urban areas in 2025, using UN figures",
      "url": "https://www.destatis.de/EN/Themes/Countries-Regions/International-Statistics/Data-Topic/Population-Labour-Social-Issues/DemographyMigration/UrbanPopulation.html"
    }
  ]
};
